import { EvaluateIllustration, PlanIllustration, SetupIllustration } from '@bp/ui-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../components/Page/Page';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

export const DeputatePage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()} title={t('deputate.title', { count: 2 })}>
      <IconMenu headline={t('common.whatToDo')}>
        <IconMenuItem
          label={t('routes.setup.title')}
          icon={<SetupIllustration />}
          bubbleType={14}
          onClick={() => navigate(t('routes.setup.slug'))}
        />
        <IconMenuItem
          label={t('routes.plan.title')}
          icon={<PlanIllustration />}
          bubbleType={16}
          onClick={() => navigate(t('routes.plan.slug'))}
        />
        <IconMenuItem
          label={t('routes.evaluate.title')}
          icon={<EvaluateIllustration />}
          bubbleType={17}
          onClick={() => navigate(t('routes.evaluate.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
